import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=ccb92b30&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=ts&"
export * from "./Category.vue?vue&type=script&lang=ts&"
import style0 from "./Category.vue?vue&type=style&index=0&id=ccb92b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb92b30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
